"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextDirection = void 0;
/** The text direction of the locale e.g. ltr or rtl */
var TextDirection;
(function (TextDirection) {
  TextDirection["LTR"] = "LTR";
  TextDirection["RTL"] = "RTL";
})(TextDirection || (exports.TextDirection = TextDirection = {}));